export default {
  'forgotPass.error.required': 'Vui lòng nhập thông tin bắt buộc.',
  'forgotPass.error.invalid.email': 'Vui lòng nhập địa chỉ email hợp lệ',
  'forgotPass.title': 'Quên mật khẩu',
  'forgotPass.sub.title': 'Vui lòng nhập địa chỉ email đã đăng ký để đặt lại mật khẩu.',
  'forgotPass.form.email': 'Email',
  'forgotPass.form.button.submit': 'Đặt lại mật khẩu',
};
